import * as actionTypes from "../actionTypes";

export const getContentList = (data) => {
  return {
    type: actionTypes.GET_CONTENT_LIST_START,
    payload: data,
  };
};
export const getContentListSuccess = (data) => {
  return {
    type: actionTypes.GET_CONTENT_LIST_SUCCESS,
    payload: data,
  };
};
export const getContentListFailure = (data) => {
  return {
    type: actionTypes.GET_CONTENT_LIST_FAILURE,
    payload: data,
  };
};

export const uploadContentsList = (data) => {
  return {
    type: actionTypes.UPLOAD_CONTENTS_LIST_START,
    payload: data,
  };
};

export const addContent = (data) => {
  return {
    type: actionTypes.ADD_CONTENT_START,
    payload: data,
  };
};
export const addContentSuccess = (data) => {
  let d = { success: data.message}
  return {
    type: actionTypes.ADD_CONTENT_SUCCESS,
    payload: d,
  };
};
export const addContentFailure = (data) => {
  let d = {};
  if(data == 'Already Exists.') d = { error: 'Old Content ID Already Exists' }
  else d = { error: 'content not created '}
  return {
    type: actionTypes.ADD_CONTENT_FAILURE,
    payload: d,
  };
};
export const contentMessageHandler = () => {
  return {
    type: actionTypes.GET_CONTENT_MESSAGE_HANDLER,
    payload: null,
  };
};
export const editContent = (data) => {
  return {
    type: actionTypes.Edit_CONTENT,
    payload: data,
  };
};
